import { render } from "./reset-password.vue?vue&type=template&id=7753ec92&ts=true"
import script from "./reset-password.ts?vue&type=script&lang=ts"
export * from "./reset-password.ts?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./reset-password.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__